import React from 'react';
import STRINGS from 'constants/strings';
import EditIcon from '@tradera/tradera-ui/icons/edit.svg?jsx';

const SignUpLink = () => (
    <a
        href="/register"
        className="slim-header__menu-link slim-header__menu-link--user px-3 d-lg-flex d-none align-items-center"
        aria-label="Bli medlem"
        title="Bli medlem"
        data-nav-signup
        data-ga-category="Header"
        data-ga-action="Navigation"
        data-ga-label="BliMedlem">
        <EditIcon className="icon icon-dark" />
        <span className="slim-header__link-text slim-header__link-text--user pl-1 d-none d-lg-inline col-auto">
            {STRINGS.REGISTER}
        </span>
    </a>
);

export default SignUpLink;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/site-header/sign-up-link.jsx